module.exports = __webpack_public_path__ + "static/media/Lafayette Cam 14.7e405933.webp";